var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3.339L9.0195 15.33L4.5675 10.878L6.048 9.3975L9.0195 12.369L19.5195 1.869L21 3.339ZM18.6795 8.631C18.816 9.2295 18.9 9.8595 18.9 10.5C18.9 15.141 15.141 18.9 10.5 18.9C5.859 18.9 2.1 15.141 2.1 10.5C2.1 5.859 5.859 2.1 10.5 2.1C12.159 2.1 13.692 2.583 14.994 3.4125L16.506 1.9005C14.805 0.7035 12.7365 0 10.5 0C4.704 0 0 4.704 0 10.5C0 16.296 4.704 21 10.5 21C16.296 21 21 16.296 21 10.5C21 9.2505 20.769 8.0535 20.37 6.9405L18.6795 8.631Z",
    fill: "#2CBF8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckStatus);
export default __webpack_public_path__ + "static/media/checkStatus.072e7d1ee1df6272a23dbe62d3e50374.svg";
export { ForwardRef as ReactComponent };